let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eXdJ6")).then(() => parcelRequire('bOc3m'));